const getEarlyAccessEvar = ({ earlyAccess }) => [
  `eVar247=eap:${earlyAccess ? "y" : "n"}`
];

export default getEarlyAccessEvar;
